import Card from "components/common/Card";
import Button from "components/semantic/Button";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMotorPreview } from "store/thunk/kyp.thunk";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import MotorLogo from "assets/icons/moterLogo.svg";
import pageLyout from "assets/icons/pageLyout.svg";
const policyType = [
  { label: "Plan Type", value: "planType" },
  { label: "Policy Number", value: "policyNumber" },
  { label: "Policy Type", value: "policyType" },
  { label: "Premium Amount", value: "premiumAmount" }
];
const policyDetails = [
  { label: "Period Of Policy", value: "periodOfPolicy" },
  { label: "Policy Issued Date", value: "policyIssuedDate" },
  { label: "Personal Accident Period of Policy", value: "personalAccidentPeriod" }
];
const agentDetails = [
  { label: "Agent Name", value: "agentName" },
  { label: "Agent Contact No.", value: "agentContacts" },
  { label: "Agent Code", value: "agentCode" }
];
const vehicleDetails = [
  { label: "Vehicle Make", value: "vehicleMake" },
  { label: "Vehicle Model", value: "vehicleModal" },
  { label: "Hypothecation/Lease", value: "hypothecatedTo" },
  { label: "Financer Name", value: "financerName" },
  { label: "IDV", value: "idvValue" },
  { label: "No Claim Bonus", value: "ncb" }
];
const MotorPreview = () => {
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const navigate = useNavigate();

  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.motorPreviewData);
  const isLoading = useAppSelector((state) => state.rootReducer.kypSlice.loadingMotorPreview);

  useEffect(() => {
    dispatch(getMotorPreview(params?.policyId));
  }, []);

  const resolvePath = (obj: any, path: string) => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };
  const handleSubmit = () => {
    navigate(`/kyp/motor-review/${params?.policyId}`);
  };
  return (
    <>
      <h1 className="text-xl sm:text-2xl font-extrabold mb-4 sm:mb-6 ">Insurance Policy Details</h1>
      <Card className="w-full flex flex-col items-center" parentClassName="rounded-md mb-7 md:mb-0 md:rounded-lg border border-gray-300 shadow-none">
        <div className="md:m-6 m-0 my-0 md:my-10">
          <Card className="w-full">
            <div className="flex items-center justify-between bg-[#ebf2f7] pl-4 flex-wrap gap-y-2 py-4 sm:py-0 rounded-t-lg md:rounded-t-2xl">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-[50px] h-[50px] bg-[#F7F7F7] flex justify-center items-center rounded-full">
                  <img src={MotorLogo} className="w-5 h-5 sm:w-6 sm:h-6" alt="Motor Logo" />
                </div>
                <div className="flex flex-col">
                  <span className="text-xs sm:text-sm font-bold">Insurance Company Name</span>
                  {isLoading ? <div className="animate-pulse h-4 md:h-6 bg-gray-300 rounded w-40 md:w-72" /> : <p className="font-bold text-sm sm:text-base lg:text-lg">{policyData?.insuranceCompanyName || "-"}</p>}
                </div>
              </div>
              <img src={pageLyout} alt="Page layout img" className="sm:block hidden" />
            </div>

            {isLoading ? (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
                {policyType.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
                {policyType.map((item: any, index: number) => {
                  if (!resolvePath(policyData, item.value)) return;
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <p className="text-sm font-medium">{resolvePath(policyData, item.value) || "-"}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {isLoading ? (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
                {policyDetails.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 border-t">
                {policyDetails.map((item: any, index: number) => {
                  if (!resolvePath(policyData, item.value)) return;
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <p className="text-sm font-medium">{resolvePath(policyData, item.value) || "-"}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {isLoading ? (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
                {policyDetails.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 border-t">
                {vehicleDetails.map((item: any, index: number) => {
                  if (!resolvePath(policyData, item.value)) return;
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <p className="text-sm font-medium">{resolvePath(policyData, item.value) || "-"}</p>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Agent Details */}
            {isLoading ? (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 ">
                {policyDetails.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <div className="animate-pulse h-4 mt-1 bg-gray-300 rounded w-full" />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 border-t">
                {agentDetails.map((item: any, index: number) => {
                  if (!resolvePath(policyData, item.value)) return;

                  return (
                    <div key={index}>
                      <p className="font-bold text-sm">{item.label}</p>
                      <p className="text-sm font-medium">{resolvePath(policyData, item.value) || "-"}</p>
                    </div>
                  );
                })}
              </div>
            )}
          </Card>
        </div>
        <div className="border-t w-full md:flex justify-center items-center py-4 px-6 hidden">
          <Button title="NEXT" className="w-full sm:w-auto" onClick={handleSubmit} isLoading={isLoading} />
        </div>
      </Card>
      <Card className="w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex md:hidden justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="NEXT" className="mx-0" onClick={handleSubmit} isLoading={isLoading} />
      </Card>
    </>
  );
};

export default MotorPreview;
